import { render, staticRenderFns } from "./TitleAndButton.vue?vue&type=template&id=4ecd5ce0"
import script from "./TitleAndButton.vue?vue&type=script&lang=js"
export * from "./TitleAndButton.vue?vue&type=script&lang=js"
import style0 from "./TitleAndButton.vue?vue&type=style&index=0&id=4ecd5ce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports